/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 测试更新ES
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class TestUpdateEsParams {
  constructor(
    public memberId?: string,
    public orderId?: string,
    public ticketFolderId?: string
  ) {}
}

export default async function (
  params: TestUpdateEsParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: any;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "delete",
    url: `/order/order/ticketFolder-test`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
